module.exports = __webpack_public_path__ + "img/icon-social.9f1965d1.svg";